import Index from '../views/LogAccess/Index'

let routes = {
    path: '/log_access',
    component: resolve => require(['../layouts/full/LayoutFull'], resolve),
    children: [
        {
            path: '/log_access',
            name: 'list-log-access',
            component: Index,
            meta: {
                pageTitle: '',
                breadcrumb: [
                    {
                        text: 'Logs de Acesso',
                        active: true,
                    },
                ],
            },
        },
    ]
};


export default routes
